module.exports = __webpack_public_path__ + "img/icon_nodata.cd6a9da1.png";